import { type ServiceDefinition } from "shared-ui-components/modularTool/modularity/serviceDefinition";
import { type ISceneContext, SceneContextIdentity } from "../../sceneContext";
import { type IWatcherService, WatcherServiceIdentity } from "../../watcherService";
import { type ISceneExplorerService, SceneExplorerServiceIdentity } from "./sceneExplorerService";

import { tokens } from "@fluentui/react-components";
import { BlurRegular } from "@fluentui/react-icons";

import { Observable } from "core/Misc/observable";
import { DefaultSectionsOrder } from "./defaultSectionsMetadata";

export const PostProcessExplorerServiceDefinition: ServiceDefinition<[], [ISceneExplorerService, ISceneContext, IWatcherService]> = {
    friendlyName: "Post Process Explorer",
    consumes: [SceneExplorerServiceIdentity, SceneContextIdentity, WatcherServiceIdentity],
    factory: (sceneExplorerService, sceneContext, watcherService) => {
        const scene = sceneContext.currentScene;
        if (!scene) {
            return undefined;
        }

        const sectionRegistration = sceneExplorerService.addSection({
            displayName: "Post Processes",
            order: DefaultSectionsOrder.PostProcesses,
            getRootEntities: () => scene.postProcesses,
            getEntityDisplayInfo: (postProcess) => {
                const onChangeObservable = new Observable<void>();

                const nameHookToken = watcherService.watchProperty(postProcess, "name", () => onChangeObservable.notifyObservers());

                return {
                    get name() {
                        return postProcess.name || `Unnamed ${postProcess.getClassName()}`;
                    },
                    onChange: onChangeObservable,
                    dispose: () => {
                        nameHookToken.dispose();
                        onChangeObservable.clear();
                    },
                };
            },
            entityIcon: () => <BlurRegular color={tokens.colorPaletteRedForeground2} />,
            getEntityAddedObservables: () => [scene.onNewPostProcessAddedObservable],
            getEntityRemovedObservables: () => [scene.onPostProcessRemovedObservable],
        });

        return {
            dispose: () => {
                sectionRegistration.dispose();
            },
        };
    },
};
